module.exports = async function (req, res, next) {
  const [url, urlParams] = req.url.split('?');

  if (url.startsWith('/applink')) {
    res.writeHead(302, {
      Location: `lev:${url
        .replace(/\/$/, '')
        .replace(/applink/, '')}?${urlParams}`,
    });
    res.end();
  }

  if (url.startsWith('/api/magic')) {
    const verifyUrl = `${process.env.VUE_APP_BOLEV_URL}${req.url}`;

    const response = await fetch(verifyUrl, {
      headers: { Accept: 'application/json' },
    });
    const json = await response.json();
    const { token, redirect } = json;
    if (token) {
      const cookies = require('cookie-universal')(req, res);
      cookies.set('x-lev-token', token);
    }
    res.writeHead(301, {
      Location: redirect || '/',
    });
    res.end();
  }
  next();
};
